'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import Branding from 'MeetingsBase/models/Branding';
import UIImage from 'UIComponents/image/UIImage';
import styled from 'styled-components';
import { OLAF, GYPSUM } from 'HubStyleTokens/colors';
import { getIsUngatedForBrandingSizingMetadata } from 'MeetingsLib/selectors/BookInfoSelectors';
export const COMPANY_LOGO_USE = {
  EMAIL_FORM: 'email-form',
  BOOKING_CONTAINER: 'booking-container'
};
const CONTAINER_HEIGHT = '92px';
const IMAGE_HEIGHT = '76px';
const Logo = styled(UIImage).withConfig({
  displayName: "CompanyLogo__Logo",
  componentId: "uj6rut-0"
})(["background-color:", ";max-height:", ";max-width:100%;"], GYPSUM, IMAGE_HEIGHT);

const CompanyLogo = props => {
  const {
    compact,
    branding: {
      logoUrl,
      logoAltText,
      logoHeight,
      companyName
    },
    heightOverride,
    use
  } = props;
  const isUngatedForBrandingSizingMetadata = useSelector(getIsUngatedForBrandingSizingMetadata);
  const [imageHasLoaded, setImageHasLoaded] = useState(false);
  useEffect(() => {
    const imageEl = document.getElementById(`logo-landmark-${use}`);
    const computedImageHeight = imageEl && getComputedStyle(imageEl, null).height;

    if (imageEl && imageHasLoaded) {
      imageEl.style.backgroundColor = use === COMPANY_LOGO_USE.EMAIL_FORM ? OLAF : GYPSUM;
    }

    if (imageEl && imageHasLoaded && computedImageHeight === '0px') {
      imageEl.style.height = IMAGE_HEIGHT;
    }

    if (imageEl && heightOverride && use === COMPANY_LOGO_USE.EMAIL_FORM) {
      imageEl.style.maxHeight = heightOverride || IMAGE_HEIGHT;
    }

    if (imageEl && use === COMPANY_LOGO_USE.BOOKING_CONTAINER && isUngatedForBrandingSizingMetadata) {
      imageEl.style.maxHeight = `${logoHeight}px` || IMAGE_HEIGHT;
    }
  }, [heightOverride, imageHasLoaded, isUngatedForBrandingSizingMetadata, logoHeight, use]);
  const hasLogo = Boolean(logoUrl);

  if (!hasLogo) {
    return null;
  }

  const classes = 'p-top-4' + (compact ? " m-bottom-4" : "");
  let alt = logoAltText;

  if (!logoAltText) {
    if (companyName) {
      alt = I18n.text('prebook.brandingAltText', {
        companyName
      });
    } else {
      alt = I18n.text('prebook.brandingAltTextNoCompany');
    }
  }

  return /*#__PURE__*/_jsx("div", {
    role: "banner",
    "aria-labelledby": "logo-landmark",
    className: classes,
    style: {
      CONTAINER_HEIGHT,
      background: use === COMPANY_LOGO_USE.EMAIL_FORM ? OLAF : GYPSUM
    },
    children: /*#__PURE__*/_jsx(Logo, {
      id: `logo-landmark-${use}`,
      className: "m-x-auto",
      src: logoUrl,
      alt: alt,
      onLoad: () => {
        setImageHasLoaded(true);
      }
    })
  });
};

CompanyLogo.propTypes = {
  compact: PropTypes.bool,
  branding: PropTypes.instanceOf(Branding).isRequired,
  use: PropTypes.string,
  heightOverride: PropTypes.string
};
export default CompanyLogo;